import {
  PROFESSIONAL_DETAILS_FETCHED_SUCCESS,
  PROFESSIONAL_DETAILS_FETCHED_FAILURE,
} from '../actions/types';

const initialState = 'NONE';

export default function professionalsDetailsFetchedReducer(
  state = initialState,
  action,
) {
  const { type, payload } = action;
  switch (type) {
    case PROFESSIONAL_DETAILS_FETCHED_SUCCESS:
      return payload;
    case PROFESSIONAL_DETAILS_FETCHED_FAILURE:
      return 'NONE';

    default:
      return state;
  }
}
